import React from 'react';

import {SvgIcon} from './SvgIcon';

const ArrowDownShortIcon: SvgIcon = ({width = 17, height = 18, classes}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classes}
  >
    <path
      d="M8.5 16.5L8.5 1.5L8.5 16.5ZM1.5 10.0714L8.5 16.5L1.5 10.0714ZM15.5 10.0714L8.5 16.5L15.5 10.0714Z"
      fill="currentColor"
    />
    <path
      d="M8.5 16.5L8.5 1.5M8.5 16.5L1.5 10.0714M8.5 16.5L15.5 10.0714"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDownShortIcon;
